/* eslint-disable */
// Parse the package.json file to get needed variables
import { ddsSpace, ddsToken } from "../design-tokens/meta";
// Used in the getColor
import colors from "../design-tokens/colors/base";
import { matchers } from "./validate-props";

export const DOC = document;
export const HTML = DOC.documentElement;
export const globalObject = typeof global !== "undefined" ? global : window;
export const prefix = ddsSpace + ddsToken;
export const supportTransitions =
    "Webkit" + "Transition" in HTML["style"] || "Transition"["toLowerCase"]() in HTML["style"];
export const transitionEndEvent =
    "Webkit" + "Transition" in HTML["style"]
        ? "Webkit"["toLowerCase"]() + "Transition" + "End"
        : "Transition"["toLowerCase"]() + "end";
export const transitionDuration =
    "Webkit" + "Duration" in HTML["style"]
        ? "Webkit"["toLowerCase"]() + "Transition" + "Duration"
        : "Transition"["toLowerCase"]() + "Duration";
export const tipPositions = /\b(top|bottom|left|right)+/;
export const isIPhone = /(IPhone)/i.test(navigator.platform);
export const isIOS =
    (/iPad|iPhone|iPod|Macintosh/i.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) &&
    !window.MSStream; // /(/(IPad)/i.test(navigator.platform)) || (/(IPhone)/i.test(navigator.platform));
export const isIE = /msie|trident|Windows Phone/i.test(navigator.userAgent);
export const isSafari = /Version\/[\d.]+.*Safari/i.test(navigator.userAgent);
export const isFirefox = /Mozilla\/[\d.]+.*Firefox/i.test(navigator.userAgent);
export const isEdge = /Edge\/1[0-8].\d+/i.test(navigator.userAgent);
export const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
export const direction = {
    UP: 1,
    RIGHT: 2,
    DOWN: 3,
    LEFT: 4,
    NONE: 5,
};

// Selection methods
export function getFullScreenOverlay() {
    var overlay = DOC.getElementById(prefix + "full-screen-overlay");
    if (!overlay) {
        console.warn(
            "OFF-CANVAS: Overlay requested. Corresponding HTML missing. Please apply id 'dds__full-screen-overlay' and class 'dds__overlay' to an empty div"
        );
        return false;
    }
    return overlay;
}

export function getElementsByClassName(element, classNAME) {
    // Returns Array
    return [].slice.call(element["getElementsByClassName"](classNAME));
}

export function getSibling(element, selector) {
    var firstChar = selector.charAt(0);
    var selectorSubstring = selector.substr(1);

    if (firstChar === ".") {
        if (element.nextElementSibling && element.nextElementSibling.classList) {
            if (element.nextElementSibling.classList.contains(selectorSubstring)) {
                return element.nextElementSibling;
            }
            return getSibling(element.nextElementSibling, selector);
        }
    } else if (firstChar === "#") {
        if (element.nextElementSibling) {
            //&& element.nextElementSibling.id) {
            if (element.nextElementSibling.id === selectorSubstring) {
                return element.nextElementSibling;
            }
            return getSibling(element.nextElementSibling, selector);
        }
    } else {
        if (element.nextElementSibling && element.nextElementSibling.tagName) {
            if (element.nextElementSibling.tagName.toLowerCase() === selector.toLowerCase()) {
                return element.nextElementSibling;
            }
            return getSibling(element.nextElementSibling, selector);
        }
    }
}

export function getFocusableElements(element) {
    var arr = Array.prototype.slice.call(
        element.querySelectorAll(
            "*:not([aria-expanded='false']) a[href],*:not([aria-expanded='false']) area[href],*:not([aria-expanded='false']) input:not([disabled]),*:not([aria-expanded='false']) select:not([disabled]),*:not([aria-expanded='false']) textarea:not([disabled]),*:not([aria-expanded='false']) button:not([disabled]):not(.dds__d-none), *:not([aria-expanded='false']) > .dds__accordion-card-body > ul > [tabindex='0']"
        )
    );
    return arr.filter(filterCollapsedParents);
}

// TODO: Make this function works for all wc. Right now only wok for notification-wc
export function getFirstFocusableElementsWC(element) {
    // TODO: generate the seletor string with all wc
    var slotAndFocusables = Array.prototype.slice.call(
        element.querySelectorAll(
            "slot,notification-wc,*:not([aria-expanded='false']) a[href],*:not([aria-expanded='false']) area[href],*:not([aria-expanded='false']) input:not([disabled]),*:not([aria-expanded='false']) select:not([disabled]),*:not([aria-expanded='false']) textarea:not([disabled]),*:not([aria-expanded='false']) button:not([disabled]):not(.dds__d-none), *:not([aria-expanded='false']) > .dds__accordion-card-body > ul > [tabindex='0']"
        )
    );
    if (slotAndFocusables.length <= 0) {
        return false;
    }

    for (var i = 0; i < slotAndFocusables.length; i++) {
        let result;
        if (slotAndFocusables[i].tagName === "SLOT") {
            result = getFirstFocusableElementsWC(slotAndFocusables[i].assignedNodes()[0]);
            if (result) {
                return result;
            }
        } else if (
            slotAndFocusables[i].tagName.substring(
                slotAndFocusables[i].length - "WC".length,
                slotAndFocusables[i].length
            ) === "WC"
        ) {
            result = getFirstFocusableElementsWC(slotAndFocusables[i].shadowRoot);
            if (result) {
                return result;
            }
        } else {
            if (
                window.getComputedStyle(slotAndFocusables[i]).getPropertyValue("display") !== "none"
            ) {
                return slotAndFocusables[i];
            }
        }
    }

    return false;
}

function filterCollapsedParents(element) {
    for (; element && element !== DOC; element = element.parentElement) {
        if (element.parentElement) {
            if (
                (element.parentElement.classList.contains("dds__collapse") &&
                    element.parentElement.getAttribute("aria-expanded") === "false") ||
                element.parentElement.classList.contains(prefix + "d-none")
            ) {
                return false;
            }
        } else {
            return element; //If scaled entire DOM tree and no parents are collapsed, element is focusable
        }
    }
}

export function getNextFocusableElement(element) {
    for (; element && element !== DOC; element = element.nextElementSibling) {
        if (element.nextElementSibling) {
            if (
                window.getComputedStyle(element.nextElementSibling).getPropertyValue("display") !==
                "none"
            ) {
                if (
                    ["A", "AREA", "INPUT", "SELECT", "TEXTAREA", "BUTTON"].indexOf(
                        element.nextElementSibling.tagName
                    ) !== -1 &&
                    element.nextElementSibling.tabIndex >= 0
                ) {
                    return element.nextElementSibling;
                }
                var focusable = getFocusableElements(element.nextElementSibling);
                if (focusable && focusable.length > 0) {
                    return focusable[0];
                }
            }
        } else {
            return getNextFocusableElement(element.parentElement);
        }
    }
}

/**
 * Creates a temporary, assertive element to announce a message for text reader clients, then removes that element.
 * @param  {String}   theMessage The short text to announce. Consider translation requirements.
 * @return void
 */
export function ariaAnnounce(theMessage) {
    var msgEl,
        randomNum = randomNumGenerator();
    document.body.appendChild(
        createElement("div", {
            style: "position:absolute; left:-1000px; width: 0px; height: 0px;",
            id: "ariaAnnouncement" + randomNum,
            "aria-live": "assertive",
        })
    );
    msgEl = document.getElementById("ariaAnnouncement" + randomNum);
    window.setTimeout(function () {
        msgEl.textContent = theMessage;
    }, 15);
    window.setTimeout(function () {
        msgEl.parentElement.removeChild(msgEl);
    }, 5000);
}

/**
 * @method getClosest   Crawls the DOM to find the closest targeted element
 * @param element       {DOM element}   the DOM element from which to start searching
 * @param selector      {string}        the class, ID, or tag name for which to search
 * @param parentsOnly   {boolean}       if false or not set, modifies TAG search to include children elements of the currently-inspected target
 * @return {element} or false
 */
export function getClosest(element, selector, parentsOnly) {
    // Element is the element and selector is for the closest parent element to find
    // updated to also make sure that once we reach document fragment (shadowroot) condition exits
    // source http://gomakethings.com/climbing-up-and-down-the-dom-tree-with-vanilla-javascript/
    var firstChar = selector.charAt(0);

    var selectorSubstring = selector.substr(1);
    if (firstChar === ".") {
        // If selector is a class
        for (
            ;
            element && element !== DOC;
            element = element.host ? element.host : element.parentNode
        ) {
            // Get closest match
            if (
                element.parentNode &&
                element.parentNode.querySelector(selector) !== null &&
                // HasClass(element, selectorSubstring)) {
                element.classList["contains"](selectorSubstring)
            ) {
                return element;
            }
            if (parentsOnly === false) {
                if (element.querySelector(selector)) {
                    return element.querySelector(selector);
                }
            }
        }
    } else if (firstChar === "#") {
        // If selector is an ID
        for (
            ;
            element && element !== DOC;
            element = element.host ? element.host : element.parentNode
        ) {
            // Get closest match
            if (element.id === selectorSubstring) {
                return element;
            }
            if (parentsOnly === false) {
                if (element.querySelector(selector)) {
                    return element.querySelector(selector);
                }
            }
        }
    } else {
        // If selector is a tagName
        for (
            ;
            element && element !== DOC;
            element = element.host ? element.host : element.parentNode
        ) {
            // Get closest match
            if (element.tagName && element.tagName.toLowerCase() === selector.toLowerCase()) {
                return element;
            }
            if (
                element.previousElementSibling &&
                element.previousElementSibling.tagName.toLowerCase() === selector.toLowerCase()
            ) {
                return element.previousElementSibling;
            }
            if (parentsOnly === false) {
                if (element.querySelector(selector)) {
                    return element.querySelector(selector);
                }
            }
        }
    }
    return false;
}

export function one(element, event, handler) {
    element.addEventListener(
        event,
        function handlerWrapper(e) {
            handler(e);
            element.removeEventListener(event, handlerWrapper, false);
        },
        false
    );
}

export function getTransitionDurationFromElement(element) {
    var duration = supportTransitions
        ? globalObject["getComputedStyle"](element)[transitionDuration]
        : 0;
    duration = parseFloat(duration);
    duration = typeof duration === "number" && !isNaN(duration) ? duration * 1000 : 0;
    return duration + 50; // We take a short offset to make sure we fire on the next frame after animation
}

export function getAnimationDurationFromElement(element) {
    var duration = supportTransitions
        ? globalObject["getComputedStyle"](element)["animationDuration"]
        : 0;
    duration = parseFloat(duration);
    duration = typeof duration === "number" && !isNaN(duration) ? duration * 1000 : 0;
    return duration + 50; // We take a short offset to make sure we fire on the next frame after animation
}

export function emulateTransitionEnd(element, handler) {
    // EmulateTransitionEnd since 2.0.4
    var called = 0;

    var duration = getTransitionDurationFromElement(element);
    supportTransitions &&
        one(element, transitionEndEvent, function (e) {
            handler(e);
            called = 1;
        });
    setTimeout(function () {
        !called && handler();
    }, duration);
}

export function emulateAnimationnEnd(element, handler) {
    // EmulateTransitionEnd since 2.0.4
    var called = 0;

    var duration = getAnimationDurationFromElement(element);
    supportTransitions &&
        one(element, transitionEndEvent, function (e) {
            handler(e);
            called = 1;
        });
    setTimeout(function () {
        !called && handler();
    }, duration);
}

export function uicoreCustomEvent(componentName, eventName, related, details) {
    var evt;
    if (isIE) {
        evt = document.createEvent("CustomEvent");
        evt.initCustomEvent("uic" + componentName + eventName, true, true, details);
    } else {
        evt = new CustomEvent("uic" + componentName + eventName, {
            bubbles: true,
            composed: true,
            detail: details,
        });
    }
    evt.relatedTarget = related;
    related.dispatchEvent(evt);
}

export function fireKeyEvent(type, key, keyCode, el) {
    var evt;
    if (isIE) {
        evt = document.createEvent("KeyboardEvent");
        evt.initKeyboardEvent(type, true, true, window, key, false, false, false, 1, false);
        //Evt.keyCode = keyCode;
    } else {
        evt = new KeyboardEvent(type, { keyCode: keyCode, which: keyCode });
    }
    el.dispatchEvent(evt);
}

// Tooltip / popover stuff
export function getScroll() {
    // Also Affix and ScrollSpy uses it
    return {
        y: globalObject.pageYOffset || HTML["scrollTop"],
        x: globalObject.pageXOffset || HTML["scrollLeft"],
    };
}

// Set new focus element since 2.0.3
export function setFocus(element) {
    element.focus ? element.focus() : element.setActive();
}

export function offWindowLeft(element, link) {
    var elementDimensions = {
        w: element["offsetWidth"],
        h: element["offsetHeight"],
    };
    var rect = link["getBoundingClientRect"]();
    if (elementDimensions.w < 50) {
        elementDimensions.w = 50;
    }
    return rect["left"] - elementDimensions.w < 0;
}

export function styleTip(link, element, position, parent, useArrow) {
    // Both popovers and tooltips (target,tooltip,placement,elementToAppendTo)
    var elementDimensions = {
        w: element["offsetWidth"],
        h: element["offsetHeight"],
    };

    useArrow = typeof useArrow === "boolean" ? useArrow : true;

    var windowWidth = HTML["clientWidth"] || DOC["body"]["clientWidth"];

    var windowHeight = HTML["clientHeight"] || DOC["body"]["clientHeight"];

    var rect = link["getBoundingClientRect"]();

    var scroll =
        parent === DOC["body"]
            ? getScroll()
            : {
                  y: parent["offsetTop"] + parent["scrollTop"],
                  x: parent["offsetLeft"] + parent["scrollLeft"],
              };

    var linkDimensions = {
        w: link.offsetWidth,
        h: link.offsetHeight,
    };

    var isPopover = element.classList["contains"]("dds__popover");

    var topPosition;

    var leftPosition;

    var arrow = element.querySelector(".dds__arrow");

    var arrowTop;

    var arrowLeft;

    var arrowWidth;

    var arrowHeight;

    var halfTopExceed = rect["top"] + linkDimensions.h / 2 - elementDimensions.h / 2 < 0;

    var halfLeftExceed = rect["left"] + linkDimensions.w / 2 - elementDimensions.w / 2 < 0;

    var halfRightExceed =
        rect["left"] + elementDimensions.w / 2 + linkDimensions.w / 2 >= windowWidth;

    var halfBottomExceed =
        rect["top"] + elementDimensions.h / 2 + linkDimensions.h / 2 >= windowHeight;

    var topExceed = rect["top"] - elementDimensions.h < 0;

    var leftExceed = rect["left"] - elementDimensions.w < 0;

    var bottomExceed = rect["top"] + elementDimensions.h + linkDimensions.h >= windowHeight;

    var rightExceed = rect["left"] + elementDimensions.w + linkDimensions.w >= windowWidth;

    // Recompute position
    var posChanged;
    if (position === "right") {
        if (!rightExceed && !halfTopExceed && !halfBottomExceed) {
            position === "right";
        } else if (rightExceed && !leftExceed && !halfTopExceed && !halfBottomExceed) {
            //If exceeds right, but fits on the left
            posChanged = true;
            position = "left";
        } else if ((!halfTopExceed || !halfBottomExceed) && (!halfRightExceed || !halfLeftExceed)) {
            //If half of top or bottom doesnt fit, try to fit top or bottom
            if (!topExceed) {
                posChanged = true;
                position = "top";
            } else if (!bottomExceed) {
                posChanged = true;
                position = "bottom";
            }
        }
    } else if (position === "left") {
        if (!leftExceed && !halfTopExceed && !halfBottomExceed) {
            position === "left";
        } else if (leftExceed && !rightExceed && !halfTopExceed && !halfBottomExceed) {
            posChanged = true;
            position = "right";
        } else if ((!halfTopExceed || !halfBottomExceed) && (!halfRightExceed || !halfLeftExceed)) {
            if (!topExceed) {
                posChanged = true;
                position = "top";
            } else if (!bottomExceed) {
                posChanged = true;
                position = "bottom";
            }
        }
    } else if (position === "top") {
        if (!topExceed && !halfRightExceed && !halfLeftExceed) {
            position === "top";
        } else if (topExceed && !bottomExceed && !halfRightExceed && !halfLeftExceed) {
            posChanged = true;
            position = "bottom";
        } else if ((!halfRightExceed || !halfLeftExceed) && (!halfTopExceed || !halfBottomExceed)) {
            //If half of right or left doesnt fit, try to fit right or left
            if (!rightExceed) {
                posChanged = true;
                position = "right";
            } else if (!leftExceed) {
                posChanged = true;
                position = "left";
            }
        }
    } else if (position === "bottom") {
        if (!bottomExceed && !halfRightExceed && !halfLeftExceed) {
            position === "bottom";
        } else if (bottomExceed && !topExceed && !halfRightExceed && !halfLeftExceed) {
            posChanged = true;
            position = "top";
        } else if ((!halfRightExceed || !halfLeftExceed) && (!halfTopExceed || !halfBottomExceed)) {
            //Can't be top
            if (!rightExceed) {
                posChanged = true;
                position = "right";
            } else if (!leftExceed) {
                posChanged = true;
                position = "left";
            }
        }
    }

    // Update tooltip/popover class
    element.className["indexOf"](position) === -1 &&
        (element.className = element.className.replace(tipPositions, position));

    // Update tooltip/popover dimensions
    if (posChanged) {
        elementDimensions = {
            w: element["offsetWidth"],
            h: element["offsetHeight"],
        };
    }
    // We check the computed width & height and update here
    arrowWidth = arrow["offsetWidth"];
    arrowHeight = arrow["offsetHeight"];

    var rectLeft = rect["left"],
        rectTop = rect["top"];
    if (!useArrow) {
        if (position === "left") {
            rectLeft = rect["left"] + arrowWidth;
        } else if (position === "right") {
            rectLeft = rect["left"] - arrowWidth;
        } else if (position === "top") {
            rectTop = rect["top"] + arrowHeight;
        } else if (position === "bottom") {
            rectTop = rect["top"] - arrowHeight;
        }
    }

    // Apply styling to tooltip or popover
    if (position === "left" || position === "right") {
        // Secondary|side positions
        if (position === "left") {
            // LEFT
            leftPosition = rectLeft + scroll.x - elementDimensions.w - (isPopover ? arrowWidth : 3); // Subtract to move more left
            window.addEventListener("resize", function () {
                arrow["style"]["left"] = "initial";
            });
        } else {
            // RIGHT
            leftPosition = rectLeft + linkDimensions.w + (isPopover ? 0 : 3); // Add to move more right
        }

        topPosition = rect["top"] - elementDimensions.h / 2 + linkDimensions.h / 2 + scroll.y;
        arrowTop = elementDimensions.h / 2 - (isPopover ? arrowHeight * 0.9 : arrowHeight / 2);
    } else if (position === "top" || position === "bottom") {
        // Primary|vertical positions
        if (position === "top") {
            // TOP
            topPosition = rectTop + scroll.y - elementDimensions.h - (isPopover ? arrowHeight : 3); // Subtract to move more up
        } else {
            // BOTTOM
            topPosition = rectTop + linkDimensions.h + scroll.y + (isPopover ? 0 : 3);
        }
        leftPosition = rect["left"] - elementDimensions.w / 2 + linkDimensions.w / 2 + scroll.x;
        arrowLeft = elementDimensions.w / 2 - arrowWidth / 2;
    }

    // Apply style to tooltip/popover and its arrow
    element["style"]["top"] = topPosition + "px";
    element["style"]["left"] = leftPosition + "px";

    arrowTop && (arrow["style"]["top"] = arrowTop + "px");
    arrowLeft && (arrow["style"]["left"] = arrowLeft + "px");
}

export function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("user-is-tabbing");

        window.removeEventListener("keydown", handleFirstTab);
        window.addEventListener("mousedown", handleMouseDownOnce);
    }
}

export function handleMouseDownOnce(e) {
    //NVDA in browse mode swallows the enter key as mouse click: https://github.com/nvaccess/nvda/issues/4903
    //This breaks our visual focus toggle. Enter key event has x,y values of 0,0 whereas click has positive x,y values.
    //Capture enter key when treated as mousedown by NVDA browse mode.
    if (e.x === 0 && e.y === 0) {
        return;
    }
    document.body.classList.remove("user-is-tabbing");

    window.removeEventListener("mousedown", handleMouseDownOnce);
    window.addEventListener("keydown", handleFirstTab);
}

export const handleFirstTabWc = (e) => {
    e.preventDefault();
    if (e.keyCode === 9) {
        e.currentTarget.classList.add("user-is-tabbing");
        e.currentTarget.removeEventListener("keyup", handleFirstTabWc);
        e.currentTarget.addEventListener("blur", handleMouseDownOnceWc);
    }
};

export const handleMouseDownOnceWc = (e) => {
    e.preventDefault();
    //NVDA in browse mode swallows the enter key as mouse click: https://github.com/nvaccess/nvda/issues/4903
    //This breaks our visual focus toggle. Enter key event has x,y values of 0,0 whereas click has positive x,y values.
    //Capture enter key when treated as mousedown by NVDA browse mode.
    if (e.x === 0 && e.y === 0) {
        return;
    }
    // Our enter event is causing us to lose our class on the :host element.
    if (e.which === 0) return;

    e.currentTarget.classList.remove("user-is-tabbing");
    if (e.currentTarget.classList.length === 0) e.currentTarget.removeAttribute("class");

    e.currentTarget.removeEventListener("blur", handleMouseDownOnceWc);
    e.currentTarget.addEventListener("keyup", handleFirstTabWc);
};

// Form--passwords validation
//================================================================
export function passwordVerification() {
    var myInput = document.getElementById("psw");
    var letter = document.getElementById("letter");
    var capital = document.getElementById("capital");
    var number = document.getElementById("number");
    var length = document.getElementById("length");

    // When the user clicks on the password field, show the message box
    myInput.onfocus = function () {
        document.getElementById("message").style.display = "block";
    };

    // When the user clicks outside of the password field, hide the message box
    myInput.onblur = function () {
        document.getElementById("message").style.display = "none";
    };

    // When the user starts to type something inside the password field
    myInput.onkeyup = function () {
        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g;
        if (myInput.value.match(lowerCaseLetters)) {
            letter.classList.add("valid");
            letter.classList.remove("invalid");
        } else {
            letter.classList.remove("valid");
            letter.classList.add("invalid");
        }

        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g;
        if (myInput.value.match(upperCaseLetters)) {
            capital.classList.remove("invalid");
            capital.classList.add("valid");
        } else {
            capital.classList.remove("valid");
            capital.classList.add("invalid");
        }

        // Validate numbers
        var numbers = /[0-9]/g;
        if (myInput.value.match(numbers)) {
            number.classList.remove("invalid");
            number.classList.add("valid");
        } else {
            number.classList.remove("valid");
            number.classList.add("invalid");
        }

        // Validate length
        if (myInput.value.length >= 8) {
            length.classList.remove("invalid");
            length.classList.add("valid");
        } else {
            length.classList.remove("valid");
            length.classList.add("invalid");
        }
    };
}

/**
 * Check is item is object
 * @return {Boolean}
 */
export function isObject(val) {
    return !!val && Object.prototype.toString.call(val) === "[object Object]";
}

/**
 * Check is item is string
 * @return {Boolean}
 */
export function isString(val) {
    return typeof val === "string";
}

/**
 * Check is item is string and not empty
 * @return {Boolean}
 */
export function isNotEmptyString(val) {
    return isString(val) && val.length;
}

/**
 * Check if item is array
 * @return {Boolean}
 */
export function isArray(val) {
    return Array.isArray(val);
}

/**
 * Check if item is Object
 * @return {Boolean}
 */
export function isHTMLElement(element) {
    return !!element && (element instanceof Element || element instanceof HTMLDocument);
}

/**
 * Check for valid JSON string
 * @param  {String}   str
 * @return {Boolean|Array|Object}
 */
export function isJson(str) {
    var t = !1;
    try {
        t = JSON.parse(str);
    } catch (e) {
        return !1;
    }
    return !(null === t || (!isArray(t) && !isObject(t))) && t;
}

/**
 * Create random number between two values.
 * The maximum is exclusive and the minimum is inclusive.
 * Defaults to 9 digits.
 * @return {Number}
 */
export function randomNumGenerator(min = 100000000, max = 999999999) {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min) + min);
}

/**
 * Iterator helper
 * @param  {(Array|Object)}   arr     Any object, array or array-like collection.
 * @param  {Function}         fn      Callback
 * @param  {Object}           scope   Change the value of this
 * @return {Void}
 */
export function each(arr, fn, scope) {
    var n;
    if (arr) {
        if (isObject(arr)) {
            for (n in arr) {
                if (Object.prototype.hasOwnProperty.call(arr, n)) {
                    fn.call(scope, arr[n], n);
                }
            }
        } else if (arr.length > 0) {
            for (n = 0; n < arr.length; n++) {
                fn.call(scope, arr[n], n);
            }
        } else {
            return false;
        }
    } else {
        return false;
    }
}

/**
 * Bubble sort algorithm
 */
export function sortItems(a, b) {
    var c, d;
    if (1 === b) {
        c = 0;
        d = a.length;
    } else {
        if (b === -1) {
            c = a.length - 1;
            d = -1;
        }
    }
    for (var e = !0; e; ) {
        e = !1;
        for (var f = c; f !== d; f += b) {
            if (a[f + b] && a[f].value > a[f + b].value) {
                var g = a[f],
                    h = a[f + b],
                    i = g;
                a[f] = h;
                a[f + b] = i;
                e = !0;
            }
        }
    }
    return a;
}

/**
 * Create DOM element node
 * @param  {String} nodeType type of node to create.
 * @param  {Object} props properties and attributes to apply to node.
 * @return {HTMLElement} newly created element.
 */
export function createElement(nodeType, props) {
    const domNode = DOC.createElement(nodeType);
    if (props && "object" === typeof props) {
        for (const prop in props) {
            if (prop === "html") {
                domNode.innerHTML = props[prop];
            } else if (prop === "text") {
                domNode.textContent = props[prop];
            } else {
                if (prop.slice(0, 5) === "aria_" || prop.slice(0, 4) === "data_") {
                    const attr = prop.slice(0, 4) + "-" + prop.slice(5);
                    domNode.setAttribute(attr, props[prop]);
                } else {
                    domNode.setAttribute(prop, props[prop]);
                }
            }
            // Set attributes on the element if passed
            if (["role", "aria-label"].includes(prop)) domNode.setAttribute(prop, props[prop]);
        }
    }
    return domNode;
}

export function renderSvg(svg, attributes) {
    var svgWrapper = DOC.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgWrapper.setAttribute("focusable", false);
    if (!isArray(svg)) {
        svg = [svg];
    }
    each(svg, function (elm) {
        var svgElem = DOC.createElementNS("http://www.w3.org/2000/svg", "use");
        svgElem.setAttributeNS(
            "http://www.w3.org/1999/xlink",
            "xlink:href",
            "#" + prefix + elm.name
        );
        svgElem.setAttribute("tabindex", "-1"); //Does this do anything
        if (elm.show) {
            classAdd(svgElem, [prefix + "show"]);
        }

        svgWrapper.appendChild(svgElem);
    });

    for (var key in attributes) {
        if (Object.prototype.hasOwnProperty.call(attributes, key)) {
            svgWrapper.setAttribute(key, attributes[key]);
        }
    }
    return svgWrapper;
}

export function renderSvgWC(svgs, wc, style) {
    if (!isArray(svgs)) {
        svgs = [svgs];
    }
    var svgSprite = document.getElementById("dds-icon-defs");
    if (svgSprite) {
        var ctnr, defs;
        if (wc.host && wc.host.shadowRoot.querySelector(wc.tagName + " svg[aria-hidden='true']")) {
            ctnr = wc.host.shadowRoot.querySelector(wc.tagName + " svg[aria-hidden='true']");
            defs = ctnr.querySelector("defs");
        } else {
            ctnr = svgSprite.cloneNode(false);
            defs = ctnr.appendChild(createElement("defs"));
        }
        each(svgs, function (name) {
            var symbol = svgSprite.querySelector("#" + name);
            if (style) {
                // Need to figure out how not to append duplicates
                var svgStyle = svgSprite.querySelector("style");
                ctnr.insertBefore(svgStyle.cloneNode(true), ctnr.firstChild);
            }
            if (!defs.querySelector("#" + name)) defs.appendChild(symbol.cloneNode(true));
        });
        wc.insertBefore(ctnr, wc.firstChild);
    }
}

/**
 * Generates DOM elements for various elements inside SVG (<g>, <path>, <circle>, <ellipse>, <rect>, etc.)
 * @param {string} svgElementType - the SVG element you want to create
 * @param {object} attributes, example to create a group: ( "g", { tabindex: "0", "aria-label": "sales trend description" } )
 * @return {svg} - SVG DOM element children, such as <path>, <circle>, etc.
 */
export function renderSvgElement(svgElementType, attributes) {
    //Svg element type: g, circle, path, etc.
    const svgElement = DOC.createElementNS("http://www.w3.org/2000/svg", svgElementType);

    if (attributes) {
        if (!isObject(attributes))
            throw Error(
                'attributes must be an object. Example: { tabindex: "0", "aria-label": "sales trend description" } '
            );

        for (const [key, value] of Object.entries(attributes)) {
            svgElement.setAttribute(key, value);
        }
    }

    return svgElement;
}

export function fetchJson(url, method, data, callback) {
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("error", function (error) {
        callback(new Error("The supplied [ " + url + " ] was invalid or had errors. \n" + error));
    });
    xhr.addEventListener("load", function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var j;
            try {
                j = JSON.parse(xhr.response);
            } catch (error) {
                callback(new Error("The response was not valid json and has errors. \n" + error));
            }
            callback(j);
        }
    });
    xhr.open(method.toUpperCase(), url, true);
    if (data) {
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    } else {
        xhr.send();
    }
}

/**
 * Function created to support the ability to add classes
 * to an SVG Element / Node. The classList for Elements and
 * Nodes in IE using createElementNS does not support classList
 * so the class attribute needs to be used
 * @param {Element/Node} elem
 */
export function classAdd(elem, classes) {
    var classList;
    if (!isArray(classes)) {
        classList = [classes];
    } else {
        classList = classes;
    }

    each(classList, function (clazz) {
        if (!elem.classList) {
            // Element does not support classList
            var newClasses = elem.getAttribute("class");
            if (!newClasses) {
                elem.setAttribute("class", clazz);
            } else {
                if (newClasses.indexOf(clazz) === -1)
                    elem.setAttribute("class", newClasses + " " + clazz);
            }
        } else {
            elem.classList.add(clazz);
        }
    });
}

/**
 * Function created to support the ability to remove classes
 * to an SVG Element / Node. The classList for Elements and
 * Nodes in IE using createElementNS does not support classList
 * so the class attribute needs to be used
 * @param {*} elem
 */
export function classRemove(elem, classes) {
    var classList;
    if (!isArray(classes)) {
        classList = [classes];
    } else {
        classList = classes;
    }
    each(classList, function (clazz) {
        if (!elem.classList) {
            // Element does not support classList
            var newClasses = elem.getAttribute("class").replace(clazz, "");
            elem.setAttribute("class", newClasses);
        } else {
            elem.classList.remove(clazz);
        }
    });
}

export function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export function ieMosaicPolyfill(slides) {
    var divTag;
    for (var i = 0; i < slides.length; i++) {
        var imgTag = slides[i].querySelector("img.dds__card-img-top");
        if (imgTag) {
            divTag = slides[i].querySelector("div.dds__card-img-top");
            divTag.style.backgroundImage = "url('" + imgTag.src + "')";
            imgTag.style.display = "none";
            slides[i].parentNode.classList.add("dds__background-img");
        }
    }
}

export function altFind(arr, callback) {
    var ret;
    each(arr, function (val) {
        var match = callback(val);
        if (match) {
            ret = val;
        }
    });
    return ret;
}

export function validateNum(num, defaultVal) {
    if (num) {
        // Check to see if page is a not a number but can be a string
        if (isNaN(num) && typeof num !== "string") {
            return defaultVal ? defaultVal : false;
            // If it is a string can it be converted to a number
        }
        if (typeof num === "string") {
            if (isNaN(parseInt(num, 10))) {
                return defaultVal ? defaultVal : false;
            }
            num = parseInt(num, 10);
        }

        return num;
    }
    return defaultVal;
}

export function jsonOptionsInit(element, options) {
    var jsonParams = element.dataset.options;
    if (jsonParams) {
        var jsonOptions = JSON.parse(jsonParams);
        return jsonOptions;
    }
    return options;
}

export function swipeInit(el, callback) {
    var swipe = new Object();
    swipe.start = {
        x: 0,
        y: 0,
    };
    swipe.end = {
        x: 0,
        y: 0,
    };
    swipe.params = {
        min: {
            x: 50,
            y: 90,
        },
        max: {
            x: 95,
            y: 100,
        },
    };
    var getTouch = function (e) {
            if (isEdge || isIE) {
                return {
                    screenX: e.screenX,
                    screenY: e.screenY,
                };
            }
            return e.touches[0];
        },
        downListener = function (e) {
            var touch = getTouch(e);
            swipe.start.x = swipe.end.x = touch.screenX;
            swipe.start.y = swipe.end.y = touch.screenY;
        },
        moveListener = function (e) {
            // PreventDefault if you want to completely stop default touch behavior
            // e.preventDefault();
            var touch = getTouch(e);
            swipe.end.x = touch.screenX;
            swipe.end.y = touch.screenY;
        },
        upListener = function () {
            if (
                (swipe.end.x - swipe.params.min.x > swipe.start.x ||
                    swipe.end.x + swipe.params.min.x < swipe.start.x) &&
                swipe.end.y < swipe.start.y + swipe.params.max.y &&
                swipe.start.y > swipe.end.y - swipe.params.max.y
            ) {
                if (swipe.end.x > swipe.start.x) {
                    swipe.direction = direction.RIGHT;
                } else {
                    swipe.direction = direction.LEFT;
                }
            }
            if (
                (swipe.end.y - swipe.params.min.y > swipe.start.y ||
                    swipe.end.y + swipe.params.min.y < swipe.start.y) &&
                swipe.end.x < swipe.start.x + swipe.params.max.x &&
                swipe.start.x > swipe.end.x - swipe.params.max.x
            ) {
                if (swipe.end.y > swipe.start.y) {
                    swipe.direction = direction.DOWN;
                } else {
                    swipe.direction = direction.UP;
                }
            }
            if (swipe.direction !== direction.NONE) {
                if (typeof callback === "function") {
                    callback(el, swipe.direction);
                }
            }
            swipe.direction = direction.NONE;
        };
    if (isEdge) {
        el.addEventListener("mousedown", downListener);
        el.addEventListener("mousemove", moveListener);
        el.addEventListener("mouseup", upListener);
    } else if (isIE) {
        el.addEventListener("pointerdown", downListener);
        el.addEventListener("pointermove", moveListener);
        el.addEventListener("pointerup", upListener);
    } else {
        el.addEventListener("touchstart", downListener);
        el.addEventListener("touchmove", moveListener);
        el.addEventListener("touchend", upListener);
    }
}

export function flush(el, ie) {
    if (el instanceof NodeList) {
        each(el, function (e) {
            flush(e, ie);
        });
    } else {
        if (ie) {
            while (el.hasChildNodes()) {
                el.removeChild(el.firstChild);
            }
        } else {
            el.innerHTML = "";
        }
    }
}

export function getText(value) {
    var text,
        div = DOC.createElement("div");
    div.innerHTML = value;

    function findText(div) {
        each(
            div.childNodes,
            function (cNode) {
                if (cNode.nodeType === 3) {
                    text = cNode.data;
                }
                findText(cNode);
            },
            this
        );
    }
    findText(div);
    return text;
}

export function populateVariants(el) {
    var variants = {};
    if (el.hasAttribute("variant")) {
        var variantAttr = el.getAttribute("variant");
        each(
            variantAttr.split(","),
            function (key) {
                variants[key.trim()] = key.trim();
            },
            el
        );
    }
    return variants;
}

/**
 * Helper method to parse the known attributes from the Web Component host. For
 * known attributes if a comman separated list is supplied the last in the list
 * wins the value.
 *
 * @param {HTMLElement} el
 * @returns {Object} known attributes objects and their passed values.
 */
export function populateAttributes(el) {
    const knownAttributes = ["variant", "align", "size", "layout", "type", "color", "dismissible"];
    const elementAttributes = {};
    knownAttributes.forEach((attributeKey) => {
        const attributeValue = el.getAttribute(attributeKey);
        // Validate the attribute value
        if (!attributeValue || typeof attributeValue !== "string") return;
        elementAttributes[attributeKey] = attributeValue.split(",").reduce((key) => {
            return key.trim();
        });
    });
    return elementAttributes;
}

export function createTemplate(el, styles) {
    return createElement("template", {
        html: (styles.outerHTML ? styles.outerHTML : styles) + (el.outerHTML ? el.outerHTML : el),
    });
}

export function createOverlay(useMasthead, isStatic, callback) {
    isStatic = typeof isStatic === "boolean" ? isStatic : true;
    useMasthead = typeof useMasthead === "boolean" ? useMasthead : false;
    var original = {},
        overlay = getFullScreenOverlay();
    if (overlay && !overlay.classList.contains(prefix + "show")) {
        overlay.classList.add(prefix + "show");
        overlay.removeAttribute("hidden");
        if (overlay.style.visibility === "hidden") {
            overlay.style.visibility = "";
        }
        if (useMasthead) {
            var masthead = DOC.querySelector("header");
            if (!masthead) {
                var mastheadWc = DOC.querySelector("masthead-wc");
                if (mastheadWc && mastheadWc.shadowRoot)
                    masthead = mastheadWc.shadowRoot.querySelector("nav");
            }
            var mastheadHeight = masthead.getBoundingClientRect().height;
            if (window.pageYOffset > mastheadHeight) {
                // If masthead not is visible
                overlay.style.top = "0px";
            } else {
                overlay.style.top = mastheadHeight - window.pageYOffset + "px";
            }
        }
    } else {
        console.warn(
            "DRAWER: Overlay requested. Corresponding HTML missing. Please apply id 'dds__full-screen-overlay' and class 'dds__overlay' to an empty div"
        );
    }
    if (!isStatic) {
        window.addEventListener("click", callback);
    }
    original.origRightPadding = DOC.body.style.paddingRight
        ? DOC.body.style.paddingRight.split("px")[0]
        : 0;
    original.scrollbarWidth = window.innerWidth - DOC.documentElement.clientWidth;
    DOC.body.style.paddingRight = original.scrollbarWidth + original.origRightPadding + "px";
    DOC.body.style.overflow = "hidden";
    DOC.documentElement.style.overflow = "hidden";
    return original;
}

export function removeOverlay(original, isStatic, callback) {
    isStatic = typeof isStatic === "boolean" ? isStatic : true;
    var overlay = getFullScreenOverlay();
    if (overlay) {
        overlay.classList.remove(prefix + "show");
        overlay.setAttribute("hidden", "");
        if (overlay.style) overlay.removeAttribute("style");
    }
    if (!isStatic) {
        window.removeEventListener("click", callback);
    }
    if (original.origRightPadding === 0 || original.scrollbarWidth > 0) {
        DOC.body.style.paddingRight = "";
    } else {
        DOC.body.style.paddingRight = original.origRightPadding + "px";
    }
    DOC.body.style.overflow = "";
    if (DOC.body.style.length === 0) {
        DOC.body.removeAttribute("style");
    }
    DOC.documentElement.style.overflow = "";
    if (DOC.documentElement.style.length === 0) {
        DOC.documentElement.removeAttribute("style");
    }
}

export function checkDateValidity(date, options) {
    var available_week_day = [];
    var todaysDate = new Date();
    todaysDate.setHours(0, 0, 0, 0);
    each(options.availableWeekDays, function (f) {
        if (f === date.getDay() || f === getWeekDay(date.getDay())) available_week_day.push(f);
    });
    //Check if valid weekday
    if (available_week_day.length === 0) {
        return false;
    }
    //Check if not before
    if (options.notBeforeDate && date <= options.notBeforeDate) {
        return false;
    }
    //Check if not after
    if (options.notAfterDate && date > options.notAfterDate) {
        return false;
    }
    // Check if before today
    if (!options.pastDates && date.getTime() <= todaysDate.getTime() - 1) {
        return false;
    }
    return true;
}

export function getWeekDay(day) {
    return ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"][day];
}

/**
 * Get a specific rule in a stylesheet.
 * @param {StyleSheet} sheet
 * @param {string} rule
 * @returns {string|boolean}
 */
export function getCSSRule(sheet, rule) {
    const classes = sheet.rules || sheet.cssRules;
    for (let i = 0; i < classes.length; i++) {
        if (classes[i].selectorText === rule) {
            return classes[i];
        }
    }
    return false;
}

/**
 * Our token colors are not in hex. Useful when users pass the token - we convert this to hex.
 * @param {string} colorToken
 * @returns {string} hex value of passed color
 */
export function getColorHex(colorToken) {
    for (const [key, value] of Object.entries(colors)) {
        if (colorToken === key) {
            return value.apply(colors);
        }
        if (colorToken.indexOf(key) > -1) {
            for (const [grpKey, grpValue] of Object.entries(value)) {
                if (colorToken === grpKey) return grpValue.apply(colors);
            }
        }
    }
}

/**
 * Component properties should be validated against expected values.
 * @param {object} props
 * @param {object} valid
 * @returns {object} - validated props
 */
export function validateProps(props, valid) {
    // If we don't have any options - set it to an empty object.
    if (!isObject(props)) {
        console.warn(`"props" is not an object. Received: ${typeof props}`);
        props = {};
    }
    // If we don't have any valid options - set it to an empty object.
    if (!isObject(valid)) {
        console.warn(`"valid" is not an object. Received: ${typeof valid}`);
        valid = {};
    }
    for (const prop in props) {
        // Check each key is valid and check each value is valid for a key.
        if (!Object.keys(valid).includes(prop) || !valid[prop].includes(props[prop])) {
            console.warn(`Invalid property "${prop}" with value "${props[prop]}" found.`);
            delete props[prop];
        }
    }
    return props;
}

/**
 * Convert a node list to array in the fastest way.
 * @param {NodeList} nl - node list
 * @returns
 */
export function toArray(nl) {
    var arr = [];
    for (var i = nl.length; i--; arr.unshift(nl[i]));
    return arr;
}

/**
 * Convert css animation-duration into miliseconds to be used
 * on setTimeout
 * @param {NodeList} nl - node list
 * @returns Number
 */
export function parseCSSDuration(css) {
    if (typeof css !== "string") {
        return null;
    }
    let time = 0;
    if (css.match(/^\d+ms$/)) {
        time = parseFloat(css.replace("ms", ""), 10);
        // eslint-disable-next-line no-useless-escape
    } else if (css.match(/^[\d\.]+s$/)) {
        time = parseFloat(css.replace("s", ""), 10) * 1000;
    }
    if (isNaN(time)) {
        console.warn("Unexpected duration format");
        time = null;
    }
    return time;
}

/**
 * IIF creating an instance of DynamicCSS to be used along with **createCSSClass**
 * This is a "singleton pattern" to guarantee that we always use the same stylesheet instance
 * @return {{getSheet:Function}}
 *  */
const DynamicCSS = (() => {
    let instance = null;
    /**
     * Return the same instnace in the case it is defined or try to capture the
     * first available matching the requiements
     * @returns {Object}
     */
    const getSheet = () => {
        if (instance) {
            if (instance.parentNode) {
                return instance;
            } else {
                // in the case instance was removed from page (SPA cases) we need to reset it
                instance = null;
            }
        }

        const stylesheets = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'));

        /**
         * The first function is a closure to capture whether checking for only styles
         * matching the ddsFilenamePatterns or anyone available in the page
         * It's prefered to try first to hook into dds files than any other
         */
        const reduceLinks = (result, link) => {
            if (result) return result;
            if (!link) return false;
            try {
                if (link.sheet && link.sheet.cssRules) {
                    result = link;
                }
            } catch (err) {
                // An error is thrown when attempt to read cssRules is made on error/loading files
                console.warn(`DynamicCSS: failed to read sheet.cssRules: ${err.message}`, link);
            }
            return result;
        };

        instance = stylesheets.reduce(reduceLinks, null);

        return instance;
    };

    return { getSheet };
})();

/**
 * Creates a new CSS class at any <style> or <link> available on the page.
 
 * Usage:
 * createCSSClass(".dds__dynamic-tmp",{display:"none"});
 * // creates a .dds__dynamic-tmp {display:"none"} in the fisrt available stylesheet
 *
 * @param {String} className The name of the dynamic class that will be created.
 * @param {{cssProp:String}} style The object with the styles you want **className** to have.
 * @returns {CSSRule}
 */
export const createCSSClass = (className, style) => {
    if (typeof className !== "string") {
        return console.error("createCSSClass: the first argument must be a string");
    }

    if (!isObject(style)) {
        return console.error("createCSSClass: the second argument must be an object");
    }

    if (!className.trim().length) {
        return console.error("createCSSClass: the className can't be empty");
    }

    if (className.indexOf(`${prefix}dynamic`) === -1) {
        console.warn(`createCSSClass: dynamic classes should have the prefix: ${prefix}dynamic`);
    }

    // Define the target that will get the dynamic classes
    const stylesheet = DynamicCSS.getSheet();
    if (!stylesheet) {
        return console.error("createCSSClass: stylesheet not found");
    }
    // Create inlined string with all **style** props
    // in:  {height:"auto","display":"none"}
    // out: "height:auto;display:none;"
    const classBody = Object.keys(style).reduce((result, styleName) => {
        result += `${styleName}:${style[styleName]};`;
        return result;
    }, "");

    const newCSS = `${className} {${classBody}}`;

    // Capture if this class name already exists and what is its index
    let legacyIndex = -1;
    let ruleIndex = stylesheet.sheet.cssRules.length;

    // Looping backwards because we push new dynamic classes to the end of the list
    while (ruleIndex > 0) {
        --ruleIndex;
        if (stylesheet.sheet.cssRules[ruleIndex].selectorText === className) {
            // Break the loop the moment we found what we need
            // and set the index that will be removed
            legacyIndex = ruleIndex;
            try {
                stylesheet.sheet.deleteRule(legacyIndex);
                break;
            } catch (err) {
                return console.error(
                    `createCSSClass: failed delete old rule with same name ${className}`,
                    err
                );
            }
        }
    }

    try {
        stylesheet.sheet.insertRule(newCSS, stylesheet.sheet.cssRules.length);
        return stylesheet.sheet.cssRules[stylesheet.sheet.cssRules.length - 1];
    } catch (err) {
        return console.error(`createCSSClass: failed to create the new rule`, err);
    }
};

/**
 * Wait for a css property to be your the value you expect it to be.
 * @param {HTMLElement} element target to capture the style from
 * @param {String} prop the name of the prop to look at as the result of a getComputedStyle object
 * @param {String} val the
 * @param {Number} maxFrames
 * @returns Promise
 */
export const waitForRender = (element, prop, val, maxFrames = 60) => {
    return new Promise((resolve, reject) => {
        if (!isHTMLElement(element)) return reject("argument *element* must implement HTMLElement");
        if (typeof prop !== "string") return reject("argument *prop* must a string");
        if (typeof val !== "string") return reject("argument *val* must be a string");
        if (typeof maxFrames !== "number") return reject("argument *maxFrames* must a number");
        try {
            const result = window.getComputedStyle(element)[prop];
            if (result === val) {
                return resolve();
            }
        } catch (err) {
            // The prop might not be valid!
            return reject(err.message);
        }
        let frame = 0;
        const nextFrame = () => {
            frame++;
            const result = window.getComputedStyle(element)[prop];
            if (frame >= maxFrames)
                return reject(`Reached maxFrames ${maxFrames} without expected results`);
            if (result === val) return resolve();
            window.requestAnimationFrame(nextFrame);
        };
        window.requestAnimationFrame(nextFrame);
    });
};

// Replaces values in string
export function replaceInString(string, replacements) {
    return string.replace(/(?:{([a-zA-Z]+)})/g, (match, group) => {
        return replacements[group];
    });
}

// Capitalizes the first letter of a string
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Determine if is in a mobile/tablet user agent
 * @returns {Boolean} - if user agent is mobile or tablet
 */
export const isMobile = () => {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
};

/**
 * Removes line breaks and tabs from string
 * @param {String} string
 * @returns {String}
 */
export const removeLineBreak = (string) => {
    return string.replace(/[\t\r\n]+/gi, "").trim();
};

/**
 * Generates an ID from a passed in string
 * https://gist.github.com/thevangelist/8ff91bac947018c9f3bfaad6487fa149?permalink_comment_id=2870157#gistcomment-2870157
 * @param {String} target
 * @returns {String}
 */
export const generateUniqueID = (target) => {
    return `${toKebabCase(target)}-${randomNumGenerator()}`;
};

/**
 * Convert a string into dash-case or kebab-case
 * @param {String} str
 * @returns {String}
 */
export const toKebabCase = (str) => {
    return str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map((x) => {
            return x.toLowerCase();
        })
        .join("-");
};

/**
 * Takes two objects and merges them into 1.
 * Arguments behave like Object.assign()
 * @param {Object} target
 * @param {Object} source
 * @returns {Object}
 */
export const deepMerge = (target, source) => {
    const _target = Object.assign({}, target);
    const _source = Object.assign({}, source);
    for (const key of Object.keys(_source)) {
        if (matchers.object(_source[key])) {
            // Check if the target can just be overwritten auto-magically.
            if (matchers.undefined(_target[key]) || matchers.null(_target[key])) continue;
            Object.assign(_source[key], deepMerge(_target[key], _source[key]));
        }
    }

    // Merge the result
    return Object.assign(_target, _source);
};

/**
 * Check to see if an object is empty.
 * @param {*} obj
 * @returns
 */
export const isEmptyObject = (obj) => {
    if (!matchers.object(obj)) return false;
    return Object.keys(obj).length === 0;
};

/**
 * Determine whether or not an element is required.
 * @param {HTMLElement} element
 * @returns
 */
export const isRequired = (element) => {
    return element.hasAttribute("required");
};

/**
 * Take a string, an array or an object of keys being classnames, and values being a boolean
 * whether or not to apply them, and returns a compiled string with classnames.
 * @param {...{Object|Array|String}} args
 * @returns {String}
 */
export const classes = (...args) => {
    return args
        .reduce((acc, value) => {
            if (matchers.string(value)) {
                return (acc += `${value} `.replace(/(^\s+|\s{2,})/, ""));
            }

            if (matchers.array(value)) {
                return (acc += value.reduce((acc, item) => acc + `${classes(item)} `, ""));
            }

            if (matchers.object(value)) {
                return (acc += Object.entries(value).reduce((acc, [key, val]) => {
                    return matchers.string(key) && matchers.truthy(val)
                        ? (acc += `${classes(key)} `)
                        : acc;
                }, ""));
            }

            return acc;
        }, "")
        .trim();
};

/**
 * Take in an array of class names and convert them into a queryable string. e.g. for querySelector
 * @param {Array} array
 * @returns {string}
 */
export const arrayToQueryString = (array) => {
    return array
        .map((c) => {
            return `.${c}`;
        })
        .join(", ");
};

/**
 * Convert a number of bytes to a properly formatted string output. e.g. 3.25GB
 * @param {Number} bytes
 * @param {Number} decimals
 */
export const formatToBytes = (bytes, decimals = 2) => {
    if (bytes <= 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];

    const exponent = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, exponent)).toFixed(dm))} ${sizes[exponent]}`;
};
/* Sort by Key
 * @param  {Array} of objects to be sorted
 * @param  {String} key for sorting
 * @return {Array} sorted
 */
export const sortByKey = (array, key = "") => {
    return array.sort((a, b) => {
        let x = a[key];
        let y = b[key];

        if (typeof x === "string") x = x.toLowerCase();
        if (typeof y === "string") y = y.toLowerCase();

        return x < y ? -1 : x > y ? 1 : 0;
    });
};

/**
 * Verify if an element has scrollbar capability
 * @param {HTMLElement} element - HTML element
 * @returns {Boolean} - element is scrollable or not
 */
export const isScrollableElement = (element) => {
    const { overflow, overflowX, overflowY } = window.getComputedStyle(element);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
};
